/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import { connect } from "react-redux";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Header from "../Layout/MerchantHeader";
import Footer from "../Layout/MerchantFooter";
import HomeBanner from "./HomeSubCompo/MerchantBanner";

import {
  apiUrl,
  deliveryId,
  pickupId,
} from "../Helpers/Config";
import {
  GET_GLOBAL_SETTINGS,
  GET_MENU_NAVIGATION,
  GET_LOYLATITY_OUTLET_DETAILS
} from "../../actions";
import {
  showLoader,
  hideLoader,
  validateEmailFun,
  showCustomAlert,
} from "../Helpers/SettingHelper";

import newletterImg from "../../common/images/newletter-bg.jpg";
import catImg from "../../common/images/menu-cat-background.jpg";
import abouttopImg from "../../common/images/about-top.png";
import aboutbottomoneImg from "../../common/images/about-bottom-one.jpg";


var Parser = require("html-react-parser");

class MerchantHome extends Component {
  constructor(props) {
    super(props);

    let pathname = props.location.pathname;
    let uriparms_one, uriparms_two = "";
    pathname = pathname.split('/');
    uriparms_one = pathname[1];
    uriparms_two = pathname[2];

    cookie.save("merchant_login_type", uriparms_two, {path:'/'});
    cookie.save("merchant_outlet_slug_name", uriparms_one, {path:'/'});

    var merchant_id = cookie.load("merchant_id") !== "" &&  cookie.load("merchant_id") !== undefined &&  cookie.load("merchant_id") !== null
      ? cookie.load("merchant_id") : ''; 


    if (merchant_id === "" || merchant_id === undefined) {
      props.history.push("/merchantlogin");
    }

    var normalpopupFlg = "initial";
    if (
      (cookie.load("triggerAvlPop") != "" &&
        cookie.load("triggerAvlPop") != undefined) ||
      cookie.load("orderPopuptrigger") === "Yes" ||
      cookie.load("loginpopupTrigger") === "Yes" ||
      cookie.load("promoPopupTrigger") === "Yes"
    ) {
      normalpopupFlg = "trigger";
    }

    this.state = {
      users: [],
      nextavail: "",
      globalSettings: [],
      cartTriggerFlg: "No",
      viewProductFlg: "no",
      viewProductSlug: "",
      normalpopuplist: [],
      normalpopupdata: [],
      normalpopup_status: "no",
      normalpopup_flg: normalpopupFlg,
      normalpopupstatus: "initial",
      promo_mail_id: "",
      displayType: "all",
      homeorderInfo: "",
      homesubscribe: "",
      testimonialBlocks:'',
      aboutus_left: '',
      aboutus_right: '',

    };

    const login_type = "Merchant";
    this.props.getSettings(login_type);
    this.props.getCompanyDetails(login_type);
  }

  componentWillReceiveProps(PropsData) {


  }



  chooseAvailability(availability) {
    var defaultAvilTy = cookie.load("defaultAvilablityId");
    if (defaultAvilTy !== availability) {
      var cartTotalItems = cookie.load("cartTotalItems");
      cartTotalItems =
        cartTotalItems != "" && cartTotalItems != undefined
          ? parseInt(cartTotalItems)
          : 0;
      if (
        cookie.load("orderOutletId") != "" &&
        cookie.load("orderOutletId") != undefined
      ) {
        this.setState({ nextavail: availability });
        $.magnificPopup.open({
          items: {
            src: "#warning-popup",
          },
          type: "inline",
        });
        return false;
      }
    }

    var popupIdtxt = "";
    if (availability === deliveryId) {
      popupIdtxt = "#delevery-popup";
    } else if (availability === pickupId) {
      popupIdtxt = "#takeaway-popup";
    }

    if (popupIdtxt !== "") {
      $.magnificPopup.open({
        items: {
          src: popupIdtxt,
        },
        type: "inline",
      });
    }
  }

  componentDidMount() {
    if (
      cookie.load("triggerAvlPop") != "" &&
      cookie.load("triggerAvlPop") != undefined
    ) {
      var availabilityId = cookie.load("triggerAvlPop");
      cookie.remove("triggerAvlPop", { path: "/" });
      this.chooseAvailability(availabilityId);
    }

    if (cookie.load("orderPopuptrigger") === "Yes") {
      cookie.remove("orderPopuptrigger", { path: "/" });
      $.magnificPopup.open({
        items: {
          src: "#order-popup",
        },
        type: "inline",
      });
    }

    if (cookie.load("loginpopupTrigger") === "Yes") {
      cookie.save("loginpopupTrigger", "fromcheckout", { path: "/" });
      $.magnificPopup.open({
        items: {
          src: "#login-popup",
        },
        type: "inline",
      });
    }

    var RctThis = this;
    $("body")
      .off("click", ".act_order_popup")
      .on("click", ".act_order_popup", function (e) {
        e.preventDefault();

        var odrType = $(this).attr("data-acturl");
        var availabilityId = "";
        if (odrType === "delivery") {
          availabilityId = deliveryId;
        } else if (odrType === "pickup") {
          availabilityId = pickupId;
        }else if (odrType === "reservation") {
          availabilityId = reservationId;
        }

        if (availabilityId !== "") {
          RctThis.chooseAvailability(availabilityId);
        } else if (availabilityId === "" && odrType === "ordernow") {
          $.magnificPopup.open({
            items: {
              src: "#order-popup",
            },
            type: "inline",
          });
        }
      });
  }

  sateValChange = (field, value) => {
    if (field === "cartflg") {
      this.setState({ cartTriggerFlg: value });
    } else if (field === "cartItem") {
      this.setState({ cartItem: value });
    } 
    
    if (field === "view_pro_data" && value !== "") {
      this.setState(
        { viewProductFlg: "yes", viewProductSlug: value },
        function () {
          this.openProDetailPopup();
        }.bind(this)
      );
    }
    if (field === "view_pro_upate" && value !== "") {
      this.setState({ viewProductFlg: value });
    }
    if (field === "firstcategory" && value !== "") {
      this.setState({ firstcategory: value });
    }
    if (field === "homeorderInfo" && value !== "") {
      this.setState({ homeorderInfo: value });
    }
    if (field === "homesubscribe" && value !== "") {
      this.setState({ homesubscribe: value });
    }
  };

  openProDetailPopup() {
    showLoader("comboPro-" + this.state.viewProductSlug, "Idtext");
    $("#ProductDetailMdl").modal({ backdrop: "static", keyboard: false });
  }

  triggerNormalPopup(trgType) {
    let settingsArr = this.props.globalsettings;
    var showPromoPopup = "",
      showNormalPopup = "";
    if (Object.keys(settingsArr).length > 0) {
      if (Object.keys(settingsArr[0].result_set).length > 0) {
        if (settingsArr[0].result_set.client_promocode_enable === "1") {
          showNormalPopup =
            settingsArr[0].result_set.client_promo_code_normal_popup_enable ===
            "1"
              ? "yes"
              : "";
          if (settingsArr[0].result_set.client_promocode_options === "1") {
            showPromoPopup =
              settingsArr[0].result_set.client_promocode_options === "1"
                ? "yes"
                : "";
          }
        }
      }
    }

    var otherPageActTrigger = "no";
    if (
      (cookie.load("triggerAvlPop") != "" &&
        cookie.load("triggerAvlPop") != undefined) ||
      cookie.load("orderPopuptrigger") === "Yes" ||
      cookie.load("loginpopupTrigger") === "Yes"
    ) {
      otherPageActTrigger = "yes";
    }
    if (showNormalPopup === "yes") {
      if (
        trgType === "loading" &&
        otherPageActTrigger === "no" &&
        this.state.normalpopup_status === "yes" &&
        Object.keys(this.state.normalpopupdata).length > 0 &&
        cookie.load("promoPopupTrigger") !== "Yes"
      ) {
        var normalpopupIds = cookie.load("normalpopupIds");
        var normalpopupIdsNew =
          normalpopupIds != "" && normalpopupIds != undefined
            ? normalpopupIds + "~~" + this.state.normalpopupdata.normalpopup_id
            : this.state.normalpopupdata.normalpopup_id;
        var normalpopupIdArr = [];
        normalpopupIdArr["normalpopupids"] = normalpopupIdsNew;
        cookie.save("normalpopupIds", normalpopupIdsNew, { path: "/" });
        var $_this_rec = this;
        $.magnificPopup.open({
          items: {
            src: "#normal-popup",
          },
          type: "inline",
          midClick: true,
          closeOnBgClick: false,
          callbacks: {
            close: function () {
              $_this_rec.normalPopupUpdate();
            },
          },
        });
      }
    }
    if (showPromoPopup === "yes") {
      if (
        (cookie.load("promoPopupTrigger") === "Yes" ||
          (otherPageActTrigger === "no" &&
            this.state.normalpopup_status === "no" &&
            Object.keys(this.state.normalpopupdata).length === 0)) &&
        cookie.load("mailpopopuptrg") !== "yes"
      ) {
        cookie.save("mailpopopuptrg", "yes", { path: "/" });
        cookie.remove("promoPopupTrigger", { path: "/" });
        $.magnificPopup.open({
          items: {
            src: "#promo-check-popup",
          },
          type: "inline",
          midClick: true,
          closeOnBgClick: false,
        });
      }
    }
  }

  normalPopupUpdate() {
    if (cookie.load("mailpopopuptrg") !== "yes") {
      this.props.history.push("/refpage/promopopup");
    }
  }

  handleEmailChange(event) {
    this.setState({ promo_mail_id: event.target.value, promomail_error: "" });
  }

  sendPromoMailFun() {
    var promoEmail = this.state.promo_mail_id;

    var mailErrorTxt = "";
    if (promoEmail === "") {
      mailErrorTxt = "Email Address is required.";
    } else if (!validateEmailFun(promoEmail)) {
      mailErrorTxt = "Invalide Email Address";
    }

    if (mailErrorTxt !== "") {
      this.setState({ promomail_error: mailErrorTxt });
      return false;
    } else {
      showLoader("promomailpopup-cls", "class");

      var qs = require("qs");
      var postObject = {
        app_id: appId,
        email_address: promoEmail,
      };

      axios
        .post(apiUrl + "promotion/user_promotion", qs.stringify(postObject))
        .then((response) => {
          hideLoader("promomailpopup-cls", "class");
          $.magnificPopup.close();
          if (response.data.status === "ok") {
            showCustomAlert(
              "success",
              "You are now a Member of Westlake Please check your email for more information."
            );
          } else {
            var errMsgtxt =
              response.data.message !== ""
                ? response.data.message
                : "Sorry! You didn`t have promo code.";
            showCustomAlert("error", errMsgtxt);
          }
          return false;
        });
    }

    return false;
  }

  setdisplayType(displayType) {
    this.setState({ displayType: displayType });
  }
  chooseAvailabilityFun(availability, event) {
    event.preventDefault();
    var defaultAvilTy = cookie.load("defaultAvilablityId");

    if (defaultAvilTy !== availability) {
      var cartTotalItems = cookie.load("cartTotalItems");
      cartTotalItems =
        cartTotalItems != "" && cartTotalItems != undefined
          ? parseInt(cartTotalItems)
          : 0;
      if (
        cookie.load("orderOutletId") != "" &&
        cookie.load("orderOutletId") != undefined
      ) {
        this.setState({ nextavail: availability });
        $.magnificPopup.open({
          items: {
            src: "#warning-popup",
          },
          type: "inline",
        });
        return false;
      }
    } else if (
      defaultAvilTy === availability &&
      cookie.load("orderOutletId") != "" &&
      cookie.load("orderOutletId") != undefined
    ) {
      $.magnificPopup.close();
      this.props.history.push("/products");
      return false;
    }else if (availability === reservationId) {
      cookie.save("defaultAvilablityId", reservationId, { path: "/" });
      $.magnificPopup.close();
      this.props.history.push("/reservation");
      return false;
    }

    var popupIdtxt = "";
    if (availability === deliveryId) {
      $(".delivery_outletpoup").find(".outlet_error").html("");
      popupIdtxt = "#delevery-redirect-popup";
    } else if (availability === pickupId) {
      popupIdtxt = "#takeaway-popup";
    } else if (availability === reservationId) {
      cookie.save("defaultAvilablityId", reservationId, { path: "/" });
      $.magnificPopup.close();
      this.props.history.push("/reservation");
      return false;
    }

    if (popupIdtxt !== "") {
      $.magnificPopup.open({
        items: {
          src: popupIdtxt,
        },
        type: "inline",
      });
    }
  }
  checkActiveDivHd(avlType) {
    var clsTxt = "";
    var availability = cookie.load("defaultAvilablityId");
    if (availability == avlType) {
      clsTxt += "active";
    }
    return clsTxt;
  }
  render() {
    
    let settingsArr = this.props.globalsettings;
    var showPromoPopup = "",
      showNormalPopup = "";


    var settingstext = {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      centerPadding: '0px',
      dots: true,
      arrows: false,
      focusOnSelect: true,
      responsive: [
       {
          breakpoint: 1080,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
          },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <div className="home-main-div">
        {/* Header section */}
        <Header
          homePageState={this.state}
          cartTriggerFlg={this.state.cartTriggerFlg}
          sateValChange={this.sateValChange}
        />
        {/* Home banner section */}
        <section className="white-home">
          <HomeBanner />
        </section>

        {/* Footer section */}
        <Footer />

      </div>
    );
  }
}

const mapStateTopProps = (state) => {

  var tempArr = Array();
  var navigateRst = Array();
  var navigateCmn = Array();
  if (Object.keys(state.product).length > 0) {
    var tempArr = !("menuNavigation" in state.product[0])
      ? Array()
      : state.product[0].menuNavigation;
    if (Object.keys(tempArr).length > 0) {
      if (tempArr[0].status === "ok") {
        navigateRst = tempArr[0].result_set;
        navigateCmn = tempArr[0].common;
      }
    }
  }

  return {
    globalsettings: state.settings,
    navigateMenu: navigateRst,
    navigateCommon: navigateCmn,
    globalsettings: state.settings,
    loyaltyoutlets: state.loyaltyoutlets,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSettings: (login_type) => {
      dispatch({ type: GET_GLOBAL_SETTINGS, login_type});
    },
    getNormalPopup: () => {
      dispatch({ type: GET_NORMAL_POPUP });
    },
    getMenuNavigation: () => {
      dispatch({ type: GET_MENU_NAVIGATION });
    },
    getCompanyDetails: (login_type) => {
      dispatch({ type: GET_LOYLATITY_OUTLET_DETAILS, login_type});
    },

  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(MerchantHome);
